import React from 'react';

import Link from 'next/link';

import { raleway, dosis } from '@/lib/fonts';
import { LOGO_TEXT, LOGO_MODE } from '@/lib/logoUtils';

interface SiteLogoWideProps {
  heightPx?: number;
  href?: string | null; // null means no link
  onClick?: () => void;
}

export const SiteLogoWide: React.FC<SiteLogoWideProps> = ({
  heightPx = 32,
  href, // No default - caller must specify
  onClick,
}) => {
  const logoText = LOGO_TEXT.WIDE;
  const font = LOGO_MODE === 'metamynd' ? dosis : raleway;

  const style = {
    fontSize: `${heightPx}px`,
    cursor: href ? 'pointer' : 'default',
  };

  if (href) {
    return (
      <Link href={href} onClick={onClick} style={{ textDecoration: 'none' }}>
        <span className={`site-logo ${font.className}`} style={style}>
          {logoText}
        </span>
      </Link>
    );
  }

  return (
    <span className={`site-logo ${font.className}`} style={style}>
      {logoText}
    </span>
  );
};
